module.exports = __webpack_public_path__ + "img/antonio-regular-unhinted-webfont.5ba0c5ca.svg";